<template>
  <div class="section section_gray section_no-padding-bottom">
    <div class="max-width">
      <div class="hero-banner">
        <div class="section__head section__head_middle">
          <div class="section__subheading fadeIn">{{ subheading }}</div>
          <h2 class="section__title">{{ title }}</h2>
          <div class="section__text">{{ text }}</div>
        </div>

        <div class="hero-banner__pic">
          <img loading="lazy" srcset="/assets/imgs/themes/zap/hero-banner.webp 1x, /assets/imgs/themes/zap/hero-banner@2x.webp 2x" src="/assets/imgs/themes/zap/hero-banner.webp">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroBannerView',
  props: {
    subheading: { type: String, required: true },
    title: { type: String, required: true },
    text: { type: String, required: true },
  }
}
</script>

<style lang="scss">
.hero-banner {
  .section__head {
    max-width:750px;
    margin-bottom:3.5rem;

    @include xs {
      margin-bottom:2rem;
    }
  }

  &__pic {
    img {
      filter:drop-shadow(0 0 21px rgba(127, 127, 127, 0.1));
    }
  }
}
</style>
